export default window.AudioContext || window.webkitAudioContext;



// WEBPACK FOOTER //
// ./src/lib/utils/InstrumentPlayer/AudioContext.js